import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const stories = [{
  name: 'Maria',
  role: 'Warehouse Associate',
  image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=90',
  quote: "After my back injury, I was terrified I wouldn't be able to provide for my kids. The nurse case manager from Arissa explained every step of my treatment. They didn't just treat my injury; they treated me like family.",
  stat: 'Returned to full duty in 8 weeks'
}, {
  name: 'David',
  role: 'Commercial Driver',
  image: 'https://images.unsplash.com/photo-1607582544086-8bcefa37ae89?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=90',
  quote: "Getting physical therapy scheduled used to be a nightmare. Arissa's ancillary team had my appointments booked the same day my doctor ordered them. I got my mobility back faster than anyone expected.",
  stat: '100% adherence to PT schedule'
}, {
  name: 'Robert & Susan',
  role: 'Retired Machinist & Spouse',
  image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=90',
  quote: 'Navigating a Medicare Set-Aside settlement felt overwhelming. The Arissa team sat down with us, explained how my future medical care would be covered, and gave us the peace of mind to finally enjoy retirement.',
  stat: 'Seamless MSA approval process'
}];
export function RecoveryStories() {
  return <section className="py-24 bg-brand-paper border-t border-gray-200" data-id="element-295">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-296">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-297">
          <h2 className="text-brand-gold font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-298">
            Real Impact
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-brand-navy mb-6" data-id="element-299">
            Stories of recovery
          </h3>
          <p className="text-lg text-gray-600" data-id="element-300">
            The true measure of our success isn't just in dollars saved—it's in
            the lives we help rebuild.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-301">
          {stories.map((story, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-shadow duration-300 border border-gray-100 flex flex-col" data-id="element-302">
              <div className="flex items-center space-x-4 mb-6" data-id="element-303">
                <img src={story.image} alt={story.name} className="w-16 h-16 rounded-full object-cover border-2 border-brand-gold/30" data-id="element-304" />
                <div data-id="element-305">
                  <h4 className="font-serif font-bold text-xl text-brand-navy" data-id="element-306">
                    {story.name}
                  </h4>
                  <p className="text-sm text-gray-500" data-id="element-307">{story.role}</p>
                </div>
              </div>

              <div className="relative flex-grow mb-8" data-id="element-308">
                <Quote className="w-8 h-8 text-brand-gold/20 absolute -top-2 -left-2" data-id="element-309" />
                <p className="text-gray-700 leading-relaxed relative z-10 italic pl-4" data-id="element-310">
                  "{story.quote}"
                </p>
              </div>

              <div className="bg-brand-navy/5 rounded-lg p-4 mt-auto border border-brand-navy/10" data-id="element-311">
                <div className="text-sm font-bold text-brand-navy flex items-center" data-id="element-312">
                  <div className="w-2 h-2 rounded-full bg-brand-gold mr-2" data-id="element-313"></div>
                  {story.stat}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}